"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Resource_1 = __importDefault(require("../../Resource"));
const class_transformer_1 = require("class-transformer");
class GenericTestAdequationResponseResource extends Resource_1.default {
}
exports.default = GenericTestAdequationResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "horizonInvestissement", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "informationModifierSituationFinanciere", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "avantagesRisquesSCPI", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "modalitesAchatPartsSCPI", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "modalitesVentePartsSCPI", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "accepterPlacementLongTerme", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "accepterNonGarantieCapital", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "accepterRisqueLiquiditeReduite", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "accepterRendementNonGaranti", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "performanceScpiFonction", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "scpiRecourtCredit", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "scpiImpacteesPar", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "fiscaliteApplicableScpi", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "horizonInvestissementCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "avantagesRisquesSCPICorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "modalitesAchatPartsSCPICorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "modalitesVentePartsSCPICorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "accepterPlacementLongTermeCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "accepterNonGarantieCapitalCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "accepterRendementNonGarantiCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "performanceScpiFonctionCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "scpiRecourtCreditCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "scpiImpacteesParCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "fiscaliteApplicableScpiCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "periodicitePiervalCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "placementPeuLiquiditeCorporation", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GenericTestAdequationResponseResource.prototype, "informationModifierSituationFinanciereCorporation", void 0);
